import Image from 'app/Components/Shared/Image/image';
//import React from 'react';
import React, {useState} from 'react';
import {SearchResult} from 'minisearch';
import classNames from 'classnames';
import {isOpen} from 'app/utilities/ActivityHoursCheck';
import {setIsShowPopup} from '../../Block/PortalsBlock/portalSlice';
import PopUp from '../../Shared/Popup/PopUp';

export default function ServiceCenter(props) {
  const hours = props.center.openingHours;
  const HoursDiv = ({text}) => {
    return (
      <>
        {text.split('$$').map((str, i) => (
          <div key={i}>{str}</div>
        ))}
      </>
    );
  };

  const [isShowPopup, setShowPopup] = useState(false);
  const wazeLink = `https://waze.com/ul?q=${encodeURIComponent(props.place)}&navigation=true`;
  const servicesInThisCenterTxt = 'שירותים הניתנים בסניף זה >';

  const setPopupStatus = () => {
    setShowPopup(!isShowPopup);
  };

  return (
    <div className={`ServiceCenter${props.isIdf ? ' isIdf' : ''}`}>
      <div className='ServiceCenter__city'>{props.center.siteDesc}</div>
      {!props.isIdf && (
        <div className='ServiceCenter__place'>
          {
            <a href={wazeLink} target='_blank'>
              <Image className='waze' src={require('./images/waze.svg')} />
            </a>
          }

          <div style={{maxWidth: '180px'}}>{props.center.address}</div>
          <Image className='location' src={require('./images/location.svg')} />
        </div>
      )}
      {hours !== '$$' ? (
        <div className='ServiceCenter__hours'>
          {!props.isIdf && <Image src={require('./images/time.svg')} />}

          <div className='week'>
            <HoursDiv text={hours} />
          </div>
        </div>
      ) : null}
      {(props.center.generalRemarks != null && props.center.generalRemarks != '') ||
      (props.center.repRemarks != null && props.center.repRemarks != '') ? (
        <div className='ServiceCenter__services' text-left='true' onClick={() => setPopupStatus()}>
          {servicesInThisCenterTxt}
        </div>
      ) : null}

      <PopUp className='' showPopUp={isShowPopup} onClose={() => setPopupStatus()}>
        <div className='ServiceCenter'>
          <div className='ServiceCenter__cityPopup'>{props.center.siteDesc}</div>
          {/* <div className='ServiceCenter__popupSubtitle'>הערות לכתובת</div>
          <div className='ServiceCenter__popupDetails'>{props.center.address}</div>
          {hours !== "$$" ?
            <div className='ServiceCenter__popupSubtitle'>שעות פתיחה
              <div className='ServiceCenter__popupDetails'><HoursDiv text={hours} /></div>
            </div> : null} */}
          <div className='ServiceCenter__popupSubtitle'>הערות כלליות</div>
          <div className='ServiceCenter__popupDetails'>
            <p>{props.center.generalRemarks}</p>
          </div>
          <div className='ServiceCenter__popupDetails'>
            <p>{props.center.repRemarks}</p>
          </div>
        </div>
      </PopUp>
    </div>
  );
}
